import React, { FC, useState, MouseEvent } from 'react'
import { LocationMap, LocationMapProps } from 'src/common/razzle-platform-map/components/LocationMap/LocationMap'


type ButtonProps = {
    onClick: (event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void
}

interface TeaserLocationMapProps extends LocationMapProps {
    children: FC<ButtonProps>
}

export const TeaserLocationMap: FC<TeaserLocationMapProps> = ({ latitude, longitude, zoom, children }) => {
    const [isDisplaying, setDisplay] = useState(false)


    if (isDisplaying) {
        return (
            <LocationMap longitude={longitude} latitude={latitude} zoom={zoom} />
        )
    }
    return children({ onClick: () => setDisplay(true) })
}
